export function dataInJs(e) {
	if (e == 'cn') {
		var rows = [
{
                searchValue: null,
                createBy: null,
                createTime: "2024-10-28",
                updateBy: null,
                updateTime: null,
                remark: null,
                params: {},
                id: 1,
                articleClass: "2",
                Image: require('@/assets/img/slkor.jpg'),
                articleTitle: "萨科微携手芯航国际，共谱半导体出海新乐章",
                articleContent: `近年来，“国产半导体出海”蔚然成风，如何在国际上开拓业务，已成为众多企业重要发展的战略之一，有人甚至喊出“不出海 就出局”的口号。作为国产半导体领域近几年发展迅速的公司，萨科微半导体（www.slkormicro.com）与金航标电子凭借不懈的努力和在国内练就的扎实基本功，在国际市场上展现出强大的发展潜力和市场竞争力，同时也积极寻求新的突破。近日，深圳市芯航国际电子有限公司正式成为萨科微的海外市场代理商，这一合作的达成，不仅为萨科微进一步开拓海外市场注入了新鲜的血液，也标志着双方在半导体领域的合作中中迈出新的一步。
	<p>
		<br />
	</p>
	<p>
                         <img src="https://www.slkormicro.com/Data/slkormicro/upload/image/20241028/6386572917591894538454911.png" width="960" height="720" alt="" />
	</p>
	<p>
		<br />
	</p>
	<p>
                         萨科微海外市场部总监丘辉林（右）为芯航国际颁发代理证
	</p>
	<p>
		<br />
	</p>
	<p>
                         深圳市芯航国际电子有限公司（www.xxintek.com）自2014年成立以来，便以成为中国最值得信赖的IC元器件贸易服务商为愿景。多年来，芯航国际凭借深厚的行业积累和优秀的代理分销能力，成功代理分销ADI、ST、TEXAS INSTRUMENTS、infineon、NXP、slkor萨科微等国际知名半导体产品。目前，芯航国际在香港、美国、欧洲、深圳、武汉、北京等地设立了分公司，形成了辐射全球的业务网络，在国内外市场赢得了近3000+客户的信赖与好评。
	</p>
	<p>
		<br />
	</p>
	<p>
                         <img src="https://www.slkormicro.com/Data/slkormicro/upload/image/20241028/6386572918754101566706414.png" width="960" height="720" alt="" />
	</p>
	<p>
		<br />
	</p>
	<p>
                         芯航国际官网首页
	</p>
	<p>
		<br />
	</p>
	<p>
                         萨科微半导体，作为中国半导体企业的出海新锋，自成立以来便致力于研发和推出高性能、高质量的半导体产品。为了满足全球客户对半导体产品的多元化需求，萨科微不断投入研发资源，拓展产品线，涵盖了二极管、晶体管、MOS管、IGBT等多个领域。同时，萨科微还积极取得了一系列国际认证，包括ISO9O01质量管理体系认证、欧盟RoHS、REACH、加州65等多项国际测试认证，这些认证不仅是对萨科微产品品质的认可，更是萨科微SLKOR国际化战略的重要成绩。
	</p>
	<p>
		<br />
	</p>
	<p>
                         <img src="https://www.slkormicro.com/Data/slkormicro/upload/image/20240930/6386329123596484375814536.png" width="960" height="720" alt="" />
	</p>
	<p>
		<br />
	</p>
	<p>
                         萨科微产品系列图
	</p>
	<p>
		<br />
	</p>
	<p>
                         萨科微slkor金航标kinghelm（www.kinghelm.net）海外市场总监丘辉林说，此次萨科微SLKOR有幸与芯航国际携手合作，是基于双方在冲出国际半导体市场上有共同的目标。两家优秀企业的合作，无疑会产生新的火花。芯航国际凭借其多年丰富的国际代理经验和广泛的业务网络，将为萨科微产品提供更广阔的展示舞台和市场机遇。而萨科微则依托高质量的产品性能和国际认证优势，为芯航国际和国产半导体在海外市场的发展带来新机遇。值得注意的是，芯航国际在即将到来的2024年德国慕尼黑国际电子元器件展上，展出萨科微半导体产品的海报，并全力推广萨科微的产品，这一决定不仅进一步提升了萨科微SLKOR（www.slkoric.com）的品牌和产品在海外的知名度，而且能提高萨科微产品为芯航国际带来新的业务增长点的机率，实现互利共赢。
	</p>
	<p>
		<br />
	</p>
	<p>
                         <img src="https://www.slkormicro.com/Data/slkormicro/upload/image/20241028/6386572920572558597861884.png" width="960" height="720" alt="" />
	</p>
	<p>
		<br />
	</p>
	<p>
                         芯航国际负责人和萨科微丘辉林
	</p>
	<p>
		<br />
	</p>
	<p>
                         期待不久的将来，萨科微SLKOR和芯航国际携手共进，双方在充分发挥各自的优势下，共同应对市场挑战，未来能够在国际市场上实现各自的愿景，也为国内半导体在国际市场上带来创新的发展。
	</p>
	<p>
		<br />
	</p>
	<p>
                         <img src="https://www.slkormicro.com/Data/slkormicro/upload/image/20241028/6386572921285449225338611.png" width="960" height="720" alt="" />`,
                state: "0"
            },
		{
			searchValue: null,
			createBy: null,
			createTime: "2024-05-15",
			updateBy: null,
			updateTime: null,
			remark: null,
			params: {},
			id: 2,
			articleClass: "2",
			Image: require('@/assets/img/tenyears.jpg'),
			articleTitle: "芯航国际十周年庆典",
			articleContent: "" +
					"<p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;2024年4月26日，芯航国际迎来了成立十周年的隆重庆典！</span></p><p><br></p>" +
					"<p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;值此芯航国际十周年庆，特向全体在职&离职的员工致以最诚挚的感谢：</span></p><p><br></p>" +
					"<p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;芯航十载，感恩同行！</span></p><p><br></p>" +
					"<p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;十年甘苦风雨兼程，十年求索岁月如歌！</span></p><p><br></p>" +
					"<p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;因为有你们，芯航国际未来可期！</span></p><p><br></p>" +
					"<p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;期待下一次周年庆典的再次相聚！</span></p><p><br></p>" +
					"<p><br></p><p><video src=\"https://xxintek.oss-cn-beijing.aliyuncs.com/tenyears.mp4\" controls autoplay loop> Your browser does not support the video tag.</video></p>" +
					"<p style=\"text-align: center;\"></p>",
			state: "0"
		}, {
			searchValue: null,
			createBy: null,
			createTime: "2022-11-10",
			updateBy: null,
			updateTime: null,
			remark: null,
			params: {},
			id: 2,
			articleClass: "2",
			Image: require('@/assets/img/cite2024.jpg'),
			articleTitle: "第十二届中国电子信息博览会（CITE2024）芯航与您相约",
			articleContent: "" +
					"<p><br></p><p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;2024年4月9日-11日，第十二届中国电子信息博览会（CITE2024）在深圳会展中心举行。</span></p>" +
					"<p><br></p><p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;芯航国际与来自世界各国的新朋老友，在这里有了一次美好的邂逅和重逢！</span></p>" +
					"<p><br></p><p><video src=\"https://xxintek.oss-cn-beijing.aliyuncs.com/cite2024.mp4\" controls autoplay loop> Your browser does not support the video tag.</video></p>" +
					"<p><span style=\"color: rgb(51, 51, 51);\">﻿</p>",
			state: "0"
		}, {
			searchValue: null,
			createBy: null,
			createTime: "2023-04-12",
			updateBy: null,
			updateTime: null,
			remark: null,
			params: {},
			id: 2,
			articleClass: "2",
			Image: require('@/assets/img/17.jpg'),
			articleTitle: "CITE2023顺利收官：芯航国际期待与您再见",
			articleContent: `<p><br></b></p><p class="MsoNormal" style="text-align:center;">\n\t<b><br />\n</b>\n</p>\n<p style="text-align:center;">\n\t<b><b><img src="https://xxintek.oss-cn-beijing.aliyuncs.com/1.jpg" alt="" /></b></b>\n</p>\n<p style="text-align:center;">\n\t<b><b></b></b>\n</p>\n<p class="MsoNormal" style="text-align:left;">\n\t<b><b>&nbsp; &nbsp; &nbsp; 2023年4月9日，第十一届中国电子信息博览会（CITE2023）在深圳会展中心顺利收官。作为展示全球电子信息产业最新产品和技术的顶级平台，中国电子信息博览会自2013年首次举办以来，经过十一载时光淬炼，一路见证了产业发展的壮阔历程，已成为推动技术创新的参与者与引领产业发展的风向标。</b></b>\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<b><b><img src="https://xxintek.oss-cn-beijing.aliyuncs.com/2.jpg" alt="" /><br />\n</b></b>\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<b><b></b></b>\n</p>\n<p class="MsoNormal" style="text-align:left;">\n\t<b><b><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本届博览会以</span><span>“</span><span>创新驱动 协同发展</span><span>”</span><span>为主题，展览面积</span><span>8</span><span>万平方米，展商各出奇招，展品争奇斗艳，来自全球各地的</span><span>1200</span><span>余家参展企业，纷纷展示新产品、新技术、新服务，展品数量超</span><span>10</span><span>万件，充分彰显了电子信息全产业链布局的广度和深度。三天展期内线上话题转发阅读量突破</span><span>6000</span><span>万人，观众人数累计突破</span><span>8</span><span>万人次。</span></b></b>\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<b><b><b><b><br />\n</b></b></b></b>\n</p>\n<p class="MsoNormal" align="center" style="text-align:center;">\n\t<b><b><span style="color:#337FE5;">重点优势分销，展会精彩不断</span></b></b>\n</p>\n<p class="MsoNormal">\n\t<b><span>芯航国际的展区重点展示了旗下知名分销品牌，如：</span><span>ADI</span><span>、</span><span>MAXIM</span><span>、</span><span>ALTERA</span><span>、</span><span>XILINX</span><span>等，吸 引了众多</span><span>&nbsp; &nbsp; </span><span>客商的驻足观看与咨询洽谈</span></b>\n</p>\n<b><br />\n</b>\n<p>\n\t<br />\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<b><b><img src="https://xxintek.oss-cn-beijing.aliyuncs.com/3.jpg" alt="" /><br />\n</b></b>\n</p>\n<b><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br />\n</b>\n<p style="text-align:center;">\n\t<img src="https://xxintek.oss-cn-beijing.aliyuncs.com/4.jpg" alt="" />\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p style="text-align:center;">\n\t<img src="https://xxintek.oss-cn-beijing.aliyuncs.com/5.jpg" alt="" />\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p class="MsoNormal">\n\t<span></span>\n</p>\n<p class="MsoNormal">\n\t<span><span>\n\t<p class="MsoNormal">\n\t\t<span>&nbsp; &nbsp; &nbsp; &nbsp;此外，我们还特备心动礼品，现场扫码即可额外获得精美笔记</span>本礼物一份。\n\t</p>\n</span></span>\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<b><img src="https://xxintek.oss-cn-beijing.aliyuncs.com/6.jpg" alt="" /><br />\n</b>\n</p>\n<b><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br />\n</b>\n<p style="text-align:center;">\n\t<img src="https://xxintek.oss-cn-beijing.aliyuncs.com/7.jpg" alt="" />\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p style="text-align:center;">\n\t<img src="https://xxintek.oss-cn-beijing.aliyuncs.com/8.jpg" alt="" />\n</p>\n</b>\n<p>\n\t<br />\n</p>\n<p style="text-align:center;">\n\t<img src="https://xxintek.oss-cn-beijing.aliyuncs.com/9.jpg" alt="" />\n</p>\n<p style="text-align:center;">\n\t<img src="https://xxintek.oss-cn-beijing.aliyuncs.com/10.jpg" alt="" />\n</p>\n</b>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p class="MsoNormal" align="center" style="text-align:center;">\n\t<b><span>努力将公司打造为国内领先的元器件企业</span></b><b></b>\n</p>\n<p class="MsoNormal">\n\t<span>公司自成立以来，业务保持高速发展，业务主要覆盖汽车电子、工业控制、电力电子、通讯网络、航空航天、物联网、医疗几大行业。</span>\n</p>\n<p>\n\t<br />\n</p>\n<p style="text-align:center;">\n\t<img src="https://xxintek.oss-cn-beijing.aliyuncs.com/11.jpg" alt="" />\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p style="text-align:center;">\n\t<img src="https://xxintek.oss-cn-beijing.aliyuncs.com/12.jpg" alt="" />\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p style="text-align:center;">\n\t<img src="https://xxintek.oss-cn-beijing.aliyuncs.com/13.jpg" alt="" />\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p class="MsoNormal" style="text-align:left;">\n\t<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;芯航始终以</span><span>“</span><span>缔造顾客信赖的一流企业</span><span>!</span><span>营造员工发展的自由空间</span><span>!</span><span>创造股东增值的公正平台</span><span>!”</span><span>为公司的发展理念；以</span><span>“</span><span>成长为</span><span>IC</span><span>行业极致服务体验的标杆</span><span>”</span><span>为愿景；以</span><span>“</span><span>服务、信任、共赢、创新</span><span>”</span><span>为价值观。最终要让客户、员工、股东实现共赢，同时将公司打造为国内领先的元器件企业</span><span>!</span>\n</p>\n<p class="MsoNormal" style="text-align:left;">\n\t<span><br />\n</span>\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<span><img src="https://xxintek.oss-cn-beijing.aliyuncs.com/14.jpg" alt="" /><br />\n</span>\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<span><img src="https://xxintek.oss-cn-beijing.aliyuncs.com/15.jpg" alt="" /><br />\n</span>\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<span><img src="https://xxintek.oss-cn-beijing.aliyuncs.com/16.jpg" alt="" /><br />\n</span>\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<span><br />\n</span>\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<span></span>\n</p>\n<p class="MsoNormal" style="text-align:left;">\n\t<span>&nbsp; &nbsp; &nbsp; &nbsp;当今世界正经历百年未有之大变局，云计算、大数据、人工智能、物联网等数字技术的蓬勃发展，推动着数字经济快速崛起，这也使得电子信息产业的重要性不断凸显。</span>\n</p>\n<p class="MsoNormal" style="text-align:left;">\n\t<span><br />\n</span>\n</p>\n<p class="MsoNormal" style="text-align:left;">\n\t<span></span>\n</p>\n<p class="MsoNormal">\n\t&nbsp; &nbsp; &nbsp; 2023<span>年是贯彻落实党的二十大精神的开局之年，又是实施</span><span>“</span><span>十四五</span><span>”</span><span>规划承上启下的关键之年，同时也是中国电子信息博览会开启新十年征程的起始之年。我们有理由相信，站在新起点的中国电子信息博览会将持续作为创新</span><span>“</span><span>强磁场</span><span>”</span><span>，助力产业创新升级，为数字经济的高质量发展不断贡献力量。</span>\n</p>\n<br />\n<p>\n\t<br />\n</p>\n<p class="MsoNormal" style="text-align:left;">\n\t<span></span>\n</p>\n<p class="MsoNormal">\n\t<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;现在，第十一届中国电子信息博览会已顺利落下帷幕，让我们共同期待下一次更加美好的重逢！</span>\n</p>\n<br />\n<p>\n\t<br />\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<b><span>联系我们</span></b>\n</p>\n<p class="p" align="center" style="text-align:center;background:#FFFFFF;">\n\t<span>公司电话</span>:0755-82056199\n</p>\n<p class="p" align="center" style="text-align:center;background:#FFFFFF;">\n\t<span>公司网站</span>:www.xxintek.com\n</p>\n<p class="p" align="center" style="text-align:center;background:#FFFFFF;">\n\t<span>公司邮箱</span>:derek.lin@xxintek.com\n</p>\n<p>\n\t<br />\n</p>\n<p>\n\t<br />\n</p>`,
			state: "0"
		}];
	} else {
		var rows = [
            {
                searchValue: null,
                createBy: null,
                createTime: "2024-10-28",
                updateBy: null,
                updateTime: null,
                remark: null,
                params: {},
                id: 1,
                articleClass: "2",
                Image: require('@/assets/img/slkor.jpg'),
                articleTitle: "Sako Microelectronics collaborates with Xinhang International to create a new chapter in semiconductor exports",
                articleContent: `In recent years, the trend of "Chinese semiconductor companies going global" has become increasingly prominent, and how to expand business internationally has become an important strategic focus for many companies. Some have even coined the slogan "Go global or be out." As a rapidly growing company in the domestic semiconductor industry, SLKOR Semiconductor (www.slkormicro.com) and Kinghelm Electronics have demonstrated strong potential and market competitiveness in the international market through their relentless efforts and solid foundation built domestically. They are also actively seeking new breakthroughs. Recently, Shenzhen Xinhang International Electronics Co., Ltd. officially became SLKOR's overseas market agent. This partnership not only injects fresh momentum into SLKOR's efforts to further expand its overseas market but also marks a new step in the cooperation between the two companies in the semiconductor field.
<p>
    <br />
</p>
<p>
                     <img src="https://www.slkormicro.com/Data/slkormicro/upload/image/20241028/6386572917591894538454911.png" width="960" height="720" alt="" />
</p>
<p>
    <br />
</p>
<p>
                     SLKOR Overseas Market Director Qiu Huilin (right) presents the agency certificate to Xinhang International
</p>
<p>
    <br />
</p>
<p>
                     Shenzhen Xinhang International Electronics Co., Ltd. (www.xxintek.com) was founded in 2014 with the vision of becoming the most trusted IC component trading service provider in China. Over the years, Xinhang International has established itself as a leading distributor of renowned international semiconductor products, including ADI, ST, TEXAS INSTRUMENTS, Infineon, NXP, and SLKOR. The company has set up branches in Hong Kong, the United States, Europe, Shenzhen, Wuhan, and Beijing, forming a global business network that has won the trust and praise of nearly 3000+ customers both domestically and internationally.
</p>
<p>
    <br />
</p>
<p>
                     <img src="https://www.slkormicro.com/Data/slkormicro/upload/image/20241028/6386572918754101566706414.png" width="960" height="720" alt="" />
</p>
<p>
    <br />
</p>
<p>
                     Xinhang International's homepage
</p>
<p>
    <br />
</p>
<p>
                     SLKOR Semiconductor, as a new force in the Chinese semiconductor industry, has been committed to developing and launching high-performance, high-quality semiconductor products since its inception. To meet the diverse needs of global customers for semiconductor products, SLKOR continues to invest in R&D resources and expand its product line, covering diodes, transistors, MOSFETs, IGBTs, and more. Additionally, SLKOR has obtained a series of international certifications, including ISO9001 quality management system certification, EU RoHS, REACH, and California Proposition 65, among others. These certifications not only recognize the quality of SLKOR's products but are also significant achievements in SLKOR's internationalization strategy.
</p>
<p>
    <br />
</p>
<p>
                     <img src="https://www.slkormicro.com/Data/slkormicro/upload/image/20240930/6386329123596484375814536.png" width="960" height="720" alt="" />
</p>
<p>
    <br />
</p>
<p>
                     SLKOR product series diagram
</p>
<p>
    <br />
</p>
<p>
                     SLKOR Semiconductor's overseas market director Qiu Huilin said that this collaboration between SLKOR and Xinhang International is based on the common goal of expanding in the international semiconductor market. The partnership between the two excellent companies will undoubtedly spark new opportunities. Leveraging its rich experience in international agency and extensive business network, Xinhang International will provide a broader stage and market opportunities for SLKOR products. On the other hand, SLKOR, with its high-quality product performance and international certification advantages, will bring new opportunities for Xinhang International and domestic semiconductors in the overseas market. Notably, Xinhang International will exhibit SLKOR Semiconductor products at the upcoming 2024 Munich International Trade Fair for Electronic Components, promoting SLKOR products aggressively. This decision not only enhances the brand and product recognition of SLKOR (www.slkoric.com) in the overseas market but also increases the likelihood of new business growth points for SLKOR products, achieving mutual benefits.
</p>
<p>
    <br />
</p>
<p>
                     <img src="https://www.slkormicro.com/Data/slkormicro/upload/image/20241028/6386572920572558597861884.png" width="960" height="720" alt="" />
</p>
<p>
    <br />
</p>
<p>
                     Xinhang International's representative and SLKOR's Qiu Huilin
</p>
<p>
    <br />
</p>
<p>
                     We look forward to the near future where SLKOR and Xinhang International will work together, leveraging their respective strengths to meet market challenges. We hope that they will achieve their visions in the international market and bring innovative development to the domestic semiconductor industry.
</p>
<p>
    <br />
</p>
<p>
                     <img src="https://www.slkormicro.com/Data/slkormicro/upload/image/20241028/6386572921285449225338611.png" width="960" height="720" alt="" />`,
                state: "0"
            },
		{
			searchValue: null,
			createBy: null,
			createTime: "2024-05-15",
			updateBy: null,
			updateTime: null,
			remark: null,
			params: {},
			id: 1,
			articleClass: "2",
			Image: require('@/assets/img/tenyears.jpg'),
			articleTitle: "10th Anniversary Celebration of Xinhang International",
			articleContent: "" +
					"<p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;On April 26, 2024, Xinhang International celebrated its 10th anniversary!</span></p><p><br></p>" +
					"<p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;On the occasion of the 10th anniversary celebration of Xinhang International, we would like to extend our sincerest gratitude to all employees who are currently employed or have resigned:</span></p><p><br></p>" +
					"<p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;Xinhang has been with you for ten years, grateful for your cooperation!</span></p><p><br></p>" +
					"<p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;Ten years of trials and tribulations, ten years of searching, years of singing!</span></p><p><br></p>" +
					"<p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;Because of you, the future of Xinhang International is promising!</span></p><p><br></p>" +
					"<p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;Looking forward to gathering again for the next anniversary celebration!</span></p><p><br></p>" +
					"<p><br></p><p><video src=\"https://xxintek.oss-cn-beijing.aliyuncs.com/tenyears.mp4\" controls autoplay loop> Your browser does not support the video tag.</video></p>" +
					"<p style=\"text-align: center;\"></p>",
			state: "0"
		}, {
			searchValue: null,
			createBy: null,
			createTime: "2022-11-10",
			updateBy: null,
			updateTime: null,
			remark: null,
			params: {},
			id: 2,
			articleClass: "2",
			Image: require('@/assets/img/cite2024.jpg'),
			articleTitle: "The 12th China Electronic Information Expo (CITE2024) is scheduled for Xinhang to meet you",
			articleContent: "" +
					"<p><br></p><p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;The 12th China Electronic Information Expo (CITE2024) was held at the Shenzhen Convention and Exhibition Center from April 9th to 11th, 2024.</span></p>" +
					"<p><br></p><p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;Xinhang International and new and old friends from all over the world have had a wonderful encounter and reunion here!</span></p>" +
					"<p><br></p><p><video src=\"https://xxintek.oss-cn-beijing.aliyuncs.com/cite2024.mp4\" controls autoplay loop> Your browser does not support the video tag.</video></p>" +
					"<p><span style=\"color: rgb(51, 51, 51);\">﻿</p>",
			state: "0"
		}, {
			searchValue: null,
			createBy: null,
			createTime: "2023-04-12",
			updateBy: null,
			updateTime: null,
			remark: null,
			params: {},
			id: 2,
			articleClass: "2",
			Image: require('@/assets/img/17.jpg'),
			articleTitle: "CITE2023 concludes smoothly: Xxintek International looks forward to seeing you again",
			articleContent: `<h1 style="text-align:center;background:#FFFFFF;">\n\t<b>CITE2023 concludes smoothly: Xxintek International looks forward to seeing you again</b><b></b>\n</h1>\n<p>\n\t<b></b>\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<b><a><span></span></a></b>\n</p>\n<p class="MsoNormal">\n\t<b><a>CITE2023&nbsp;comes&nbsp;to&nbsp;a&nbsp;successful&nbsp;close:&nbsp;Xxintek&nbsp;co.,&nbsp;Limited&nbsp;&nbsp;looks&nbsp;forward&nbsp;to&nbsp;seeing&nbsp;you&nbsp;again.</a></b>\n</p>\n<b><span></span></b>\n<p>\n\t<br />\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<b><br />\n</b>\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<b><br />\n</b>\n</p>\n<p style="text-align:center;">\n\t<b><b><img src="https://xxintek.oss-cn-beijing.aliyuncs.com/1.jpg" alt="" /></b></b>\n</p>\n<p style="text-align:center;">\n\t<b><b></b></b>\n</p>\n<p class="MsoNormal" style="text-align:left;">\n\t<span style="font-weight:bold;">On&nbsp;April&nbsp;9,&nbsp;2023,&nbsp;the&nbsp;11th&nbsp;China&nbsp;Information&nbsp;Technology&nbsp;Expo&nbsp;(CITE2023)&nbsp;successfully&nbsp;concluded&nbsp;at&nbsp;the&nbsp;Shenzhen&nbsp;Convention&nbsp;and&nbsp;Exhibition&nbsp;Center.&nbsp;As&nbsp;the&nbsp;top&nbsp;platform&nbsp;for&nbsp;showcasing&nbsp;the&nbsp;latest&nbsp;products&nbsp;and&nbsp;technologies&nbsp;in&nbsp;the&nbsp;global&nbsp;electronics&nbsp;information&nbsp;industry,&nbsp;the&nbsp;China&nbsp;Information&nbsp;Technology&nbsp;Expo&nbsp;has&nbsp;witnessed&nbsp;the&nbsp;magnificent&nbsp;development&nbsp;of&nbsp;the&nbsp;industry&nbsp;over&nbsp;the&nbsp;past&nbsp;eleven&nbsp;years&nbsp;since&nbsp;its&nbsp;first&nbsp;launch&nbsp;in&nbsp;2013,&nbsp;and&nbsp;has&nbsp;become&nbsp;a&nbsp;participant&nbsp;in&nbsp;promoting&nbsp;technological&nbsp;innovation&nbsp;and&nbsp;a&nbsp;trendsetter&nbsp;in&nbsp;industry&nbsp;development.</span>\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<b><b><img src="https://xxintek.oss-cn-beijing.aliyuncs.com/2.jpg" alt="" /><br />\n</b></b>\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<b><b></b></b>\n</p>\n<p class="MsoNormal" style="text-align:left;">\n\t<span style="font-weight:bold;">With&nbsp;the&nbsp;theme&nbsp;of&nbsp;"InnovationDriven,&nbsp;Collaborative&nbsp;Development,"&nbsp;the&nbsp;exhibition&nbsp;covered&nbsp;an&nbsp;area&nbsp;of&nbsp;80,000&nbsp;square&nbsp;meters.&nbsp;With&nbsp;various&nbsp;innovative&nbsp;ideas&nbsp;from&nbsp;exhibitors&nbsp;and&nbsp;over&nbsp;1200&nbsp;participating&nbsp;companies&nbsp;from&nbsp;around&nbsp;the&nbsp;world,&nbsp;new&nbsp;products,&nbsp;technologies,&nbsp;and&nbsp;services&nbsp;were&nbsp;showcased&nbsp;with&nbsp;over&nbsp;100,000&nbsp;items&nbsp;on&nbsp;display,&nbsp;fully&nbsp;demonstrating&nbsp;the&nbsp;breadth&nbsp;and&nbsp;depth&nbsp;of&nbsp;the&nbsp;electronics&nbsp;information&nbsp;industry&nbsp;chain.&nbsp;During&nbsp;the&nbsp;three-day&nbsp;exhibition,&nbsp;the&nbsp;online&nbsp;topic&nbsp;forwarding&nbsp;and&nbsp;reading&nbsp;volume&nbsp;exceeded&nbsp;60&nbsp;million,&nbsp;and&nbsp;the&nbsp;total&nbsp;number&nbsp;of&nbsp;visitors&nbsp;exceeded&nbsp;80,000.</span>\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<b><b><b><b><br />\n</b></b></b></b>\n</p>\n<p class="MsoNormal" align="center" style="text-align:center;">\n\t<b><b><span style="color:#337FE5;"></span></b></b>\n</p>\n<p class="MsoNormal" align="center" style="text-align:center;">\n\t<b><b><b>Key&nbsp;advantages&nbsp;of&nbsp;distribution,&nbsp;the&nbsp;exhibition&nbsp;is&nbsp;constantly&nbsp;exciting.</b><b></b></b></b>\n</p>\n<p>\n\t<br />\n</p>\n<p class="MsoNormal">\n\t<b><span></span></b>\n</p>\n<p class="MsoNormal">\n\t<b>Xxintek&nbsp;co.,&nbsp;Limited’<span>s</span>&nbsp;&nbsp;booth&nbsp;prominently&nbsp;showcased&nbsp;its&nbsp;wellknown&nbsp;distribution&nbsp;brands&nbsp;such&nbsp;as&nbsp;ADI,&nbsp;MAXIM,&nbsp;ALTERA,&nbsp;and&nbsp;XILINX,&nbsp;attracting&nbsp;numerous&nbsp;visitors&nbsp;to&nbsp;stop&nbsp;and&nbsp;observe&nbsp;and&nbsp;consult.</b>\n</p>\n<b><span></span></b>\n<p>\n\t<br />\n</p>\n<b><br />\n</b>\n<p>\n\t<br />\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<b><b><img src="https://xxintek.oss-cn-beijing.aliyuncs.com/3.jpg" alt="" /><br />\n</b></b>\n</p>\n<b><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br />\n</b>\n<p style="text-align:center;">\n\t<img src="https://xxintek.oss-cn-beijing.aliyuncs.com/4.jpg" alt="" />\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p style="text-align:center;">\n\t<img src="https://xxintek.oss-cn-beijing.aliyuncs.com/5.jpg" alt="" />\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p class="MsoNormal">\n\t<span></span>\n</p>\n<p class="MsoNormal">\n\t<span><span></span></span>\n</p>\n<p class="MsoNormal">\n\t<span></span>\n</p>\n<p class="MsoNormal">\n\tIn&nbsp;addition,&nbsp;we&nbsp;also&nbsp;prepared&nbsp;special&nbsp;gifts.&nbsp;Visitors&nbsp;who&nbsp;scanned&nbsp;the&nbsp;QR&nbsp;code&nbsp;at&nbsp;our&nbsp;booth&nbsp;could&nbsp;receive&nbsp;an&nbsp;exquisite&nbsp;notebook&nbsp;gift.\n</p>\n<p>\n\t<br />\n</p>\n<span></span>\n<p>\n\t<br />\n</p>\n<p>\n\t<br />\n</p>\n<p>\n\t<br />\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<b><img src="https://xxintek.oss-cn-beijing.aliyuncs.com/6.jpg" alt="" /><br />\n</b>\n</p>\n<b><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br />\n</b>\n<p style="text-align:center;">\n\t<img src="https://xxintek.oss-cn-beijing.aliyuncs.com/7.jpg" alt="" />\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p style="text-align:center;">\n\t<img src="https://xxintek.oss-cn-beijing.aliyuncs.com/8.jpg" alt="" />\n</p>\n</b>\n<p>\n\t<br />\n</p>\n<p style="text-align:center;">\n\t<img src="https://xxintek.oss-cn-beijing.aliyuncs.com/9.jpg" alt="" />\n</p>\n<p style="text-align:center;">\n\t<img src="https://xxintek.oss-cn-beijing.aliyuncs.com/10.jpg" alt="" />\n</p>\n</b>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p class="MsoNormal" align="center" style="text-align:center;">\n\t<b><span></span></b>\n</p>\n<p class="MsoNormal" align="center" style="text-align:center;">\n\t<b><b><span></span></b></b>\n</p>\n<p class="MsoNormal">\n\t<b><b><b>Efforts&nbsp;to&nbsp;build&nbsp;the&nbsp;company&nbsp;into&nbsp;a&nbsp;leading&nbsp;electronic&nbsp;component&nbsp;enterprise&nbsp;in&nbsp;China</b></b></b>\n</p>\n<b><b></b>\n<p>\n\t<br />\n</p>\n</b><b></b>\n<p>\n\t<br />\n</p>\n<p class="MsoNormal">\n\t<span></span>\n</p>\n<p class="MsoNormal">\n\tSince&nbsp;its&nbsp;establishment,&nbsp;the&nbsp;company's&nbsp;business&nbsp;has&nbsp;maintained&nbsp;rapid&nbsp;development,&nbsp;covering&nbsp;mainly&nbsp;the&nbsp;automotive&nbsp;electronics,&nbsp;industrial&nbsp;control,power&nbsp;electronics,&nbsp;communication&nbsp;networks,&nbsp;aerospace,&nbsp;IoT,&nbsp;and&nbsp;medical&nbsp;industries.\n</p>\n<p>\n\t<br />\n</p>\n<p>\n\t<br />\n</p>\n<p style="text-align:center;">\n\t<img src="https://xxintek.oss-cn-beijing.aliyuncs.com/11.jpg" alt="" />\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p style="text-align:center;">\n\t<img src="https://xxintek.oss-cn-beijing.aliyuncs.com/12.jpg" alt="" />\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p style="text-align:center;">\n\t<img src="https://xxintek.oss-cn-beijing.aliyuncs.com/13.jpg" alt="" />\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p style="text-align:center;">\n\t<br />\n</p>\n<p class="MsoNormal" style="text-align:left;">\n\t<span></span>\n</p>\n<p class="MsoNormal">\n\tXxintek&nbsp;co.,&nbsp;Limited&nbsp;&nbsp;has&nbsp;always&nbsp;taken&nbsp;"Creating&nbsp;a&nbsp;firstclass&nbsp;enterprise&nbsp;trusted&nbsp;by&nbsp;customers!&nbsp;Creating&nbsp;a&nbsp;free&nbsp;space&nbsp;for&nbsp;employee&nbsp;development!&nbsp;Creating&nbsp;a&nbsp;fair&nbsp;platform&nbsp;for&nbsp;shareholder&nbsp;value&nbsp;creation!"&nbsp;as&nbsp;its&nbsp;development&nbsp;philosophy,&nbsp;"Growing&nbsp;into&nbsp;the&nbsp;benchmark&nbsp;of&nbsp;IC&nbsp;industry&nbsp;service&nbsp;experience"&nbsp;as&nbsp;its&nbsp;vision,&nbsp;and&nbsp;"Service,&nbsp;Trust,&nbsp;Win-win,&nbsp;and&nbsp;Innovation"&nbsp;as&nbsp;its&nbsp;values.&nbsp;Ultimately,&nbsp;we&nbsp;want&nbsp;to&nbsp;achieve&nbsp;a&nbsp;win-win&nbsp;situation&nbsp;for&nbsp;customers,&nbsp;employees,&nbsp;and&nbsp;shareholders,&nbsp;and&nbsp;build&nbsp;the&nbsp;company&nbsp;into&nbsp;a&nbsp;leading&nbsp;electronic&nbsp;component&nbsp;enterprise&nbsp;in&nbsp;China!\n</p>\n<span></span>\n<p>\n\t<br />\n</p>\n<p class="MsoNormal" style="text-align:left;">\n\t<span><br />\n</span>\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<span><img src="https://xxintek.oss-cn-beijing.aliyuncs.com/14.jpg" alt="" /><br />\n</span>\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<span><img src="https://xxintek.oss-cn-beijing.aliyuncs.com/15.jpg" alt="" /><br />\n</span>\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<span><img src="https://xxintek.oss-cn-beijing.aliyuncs.com/16.jpg" alt="" /><br />\n</span>\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<span><br />\n</span>\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\t<span></span>\n</p>\n<p class="MsoNormal" style="text-align:left;">\n\t<span></span>\n</p>\n<p class="MsoNormal">\n\tThe&nbsp;world&nbsp;is&nbsp;currently&nbsp;experiencing&nbsp;unprecedented&nbsp;changes,&nbsp;with&nbsp;the&nbsp;booming&nbsp;development&nbsp;of&nbsp;digital&nbsp;technologies&nbsp;such&nbsp;as&nbsp;cloud&nbsp;computing,&nbsp;big&nbsp;data,&nbsp;artificial&nbsp;intelligence,&nbsp;and&nbsp;the&nbsp;Internet&nbsp;of&nbsp;Things,&nbsp;which&nbsp;is&nbsp;driving&nbsp;the&nbsp;rapid&nbsp;rise&nbsp;of&nbsp;the&nbsp;digital&nbsp;economy&nbsp;and&nbsp;highlighting&nbsp;the&nbsp;importance&nbsp;of&nbsp;the&nbsp;electronics&nbsp;information&nbsp;industry.\n</p>\n<p>\n\t<br />\n</p>\n<p class="MsoNormal" style="text-align:left;">\n\t<span><br />\n</span>\n</p>\n<p class="MsoNormal" style="text-align:left;">\n\t<span></span>\n</p>\n<p class="MsoNormal">\n\t<br />\n</p>\n<p class="MsoNormal">\n\t2023&nbsp;is&nbsp;the&nbsp;beginning&nbsp;of&nbsp;implementing&nbsp;the&nbsp;spirit&nbsp;of&nbsp;the&nbsp;19th&nbsp;National&nbsp;Congress&nbsp;of&nbsp;the&nbsp;Communist&nbsp;Party&nbsp;of&nbsp;China,&nbsp;and&nbsp;it&nbsp;is&nbsp;also&nbsp;the&nbsp;key&nbsp;year&nbsp;for&nbsp;implementing&nbsp;the&nbsp;14th&nbsp;FiveYear&nbsp;Plan.&nbsp;Meanwhile,&nbsp;it&nbsp;is&nbsp;also&nbsp;the&nbsp;starting&nbsp;year&nbsp;for&nbsp;the&nbsp;new&nbsp;decade&nbsp;of&nbsp;the&nbsp;China&nbsp;Information&nbsp;Technology&nbsp;Expo.&nbsp;We&nbsp;have&nbsp;reason&nbsp;to&nbsp;believe&nbsp;that&nbsp;the&nbsp;China&nbsp;Information&nbsp;Technology&nbsp;Expo,&nbsp;standing&nbsp;at&nbsp;a&nbsp;new&nbsp;starting&nbsp;point,&nbsp;will&nbsp;continue&nbsp;to&nbsp;serve&nbsp;as&nbsp;an&nbsp;innovative&nbsp;"strong&nbsp;magnetic&nbsp;field,"&nbsp;assisting&nbsp;in&nbsp;industry&nbsp;innovation&nbsp;and&nbsp;upgrading&nbsp;and&nbsp;contributing&nbsp;to&nbsp;the&nbsp;high-quality&nbsp;development&nbsp;of&nbsp;the&nbsp;digital&nbsp;economy.\n</p>\n<span></span>\n<p>\n\t<br />\n</p>\n<br />\n<p>\n\t<br />\n</p>\n<p class="MsoNormal" style="text-align:left;">\n\t<span></span>\n</p>\n<p class="MsoNormal">\n\t<span></span>\n</p>\n<p class="MsoNormal">\n\tNow,&nbsp;the&nbsp;11th&nbsp;China&nbsp;Information&nbsp;Technology&nbsp;Expo&nbsp;has&nbsp;successfully&nbsp;concluded.&nbsp;Let&nbsp;us&nbsp;look&nbsp;forward&nbsp;to&nbsp;a&nbsp;better&nbsp;reunion&nbsp;next&nbsp;time!\n</p>\n<p>\n\t<br />\n</p>\n<br />\n<p class="MsoNormal" style="text-align:center;">\n\t<br />\n</p>\n<p class="p" align="center" style="text-align:center;background:#FFFFFF;">\n\tContact&nbsp;Us\n</p>\n<p class="p" align="center" style="text-align:center;background:#FFFFFF;">\n\tTel:&nbsp;0755-82056199\n</p>\n<p class="p" align="center" style="text-align:center;background:#FFFFFF;">\n\tWebsite:&nbsp;www.xxintek.com\n</p>\n<p class="MsoNormal" style="text-align:center;">\n\tEmail:&nbsp;derek.lin@xxintek.com\n</p>\n<br />\n<p>\n\t<br />\n</p>\n<p>\n\t<br />\n</p>`,
			state: "0"
		}];
	}
	return rows;
}

export function agentInfo() {
	var rows = [{
			searchValue: null,
			createBy: null,
			createTime: null,
			updateBy: null,
			updateTime: null,
			remark: null,
			params: {},
			id: 1,
			name: "ES",
			classification: "0",
			brandImage: require('@/assets/img/brand/ES.png'),
			introduction: null,
			state: "0"
		},
		{
			searchValue: null,
			createBy: null,
			createTime: null,
			updateBy: null,
			updateTime: null,
			remark: null,
			params: {},
			id: 1,
			name: "NAIKETE",
			classification: "0",
			brandImage: require('@/assets/img/brand/NAIKETE.png'),
			introduction: null,
			state: "0"
		},
		{
			searchValue: null,
			createBy: null,
			createTime: null,
			updateBy: null,
			updateTime: null,
			remark: null,
			params: {},
			id: 1,
			name: "ALLPOWER",
			classification: "0",
			brandImage: require('@/assets/img/brand/ALLPOWER.jpg'),
			introduction: null,
			state: "0"
		},
		/*{
			searchValue: null,
			createBy: null,
			createTime: null,
			updateBy: null,
			updateTime: null,
			remark: null,
			params: {},
			id: 1,
			name: "ASNT",
			classification: "0",
			brandImage: require('@/assets/img/brand/ASNT.png'),
			introduction: null,
			state: "0"
		},*/
		{
			searchValue: null,
			createBy: null,
			createTime: null,
			updateBy: null,
			updateTime: null,
			remark: null,
			params: {},
			id: 1,
			name: "henlv",
			classification: "0",
			brandImage: require('@/assets/img/brand/henlv.jpg'),
			introduction: null,
			state: "0"
		},
         {
             searchValue: null,
             createBy: null,
             createTime: null,
             updateBy: null,
             updateTime: null,
             remark: null,
             params: {},
             id: 1,
             name: "slkor",
             classification: "0",
             brandImage: require('@/assets/img/brand/slkor.jpg'),
             introduction: null,
             state: "0"
         }
	];
	return rows;
}

export function brandInfo() {
	var rows = [{
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 1,
		name: "IDT",
		classification: "0",
		brandImage: require('@/assets/img/brand/IDT.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 2,
		name: "LINEAR",
		classification: "0",
		brandImage: require('@/assets/img/brand/LINEAR.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 3,
		name: "ANALOGDEVICES",
		classification: "0",
		brandImage: require('@/assets/img/brand/ANALOGDEVICES.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 4,
		name: "MAXIM",
		classification: "0",
		brandImage: require('@/assets/img/brand/MAXIM.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 5,
		name: "freescale",
		classification: "0",
		brandImage: require('@/assets/img/brand/freescale.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 6,
		name: "national semiconductor",
		classification: "0",
		brandImage: require('@/assets/img/brand/nationalSemiconductor.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 7,
		name: "TEXAS INSTERUMENTS",
		classification: "0",
		brandImage: require('@/assets/img/brand/TEXAS_INSTERUMENTS.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 8,
		name: "ALBRA",
		classification: "0",
		brandImage: require('@/assets/img/brand/ALBRA.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 9,
		name: "XILINX",
		classification: "0",
		brandImage: require('@/assets/img/brand/XILINX.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 10,
		name: "international rectfier",
		classification: "0",
		brandImage: require('@/assets/img/brand/internationalRectfier.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 11,
		name: "Microsemi",
		classification: "0",
		brandImage: require('@/assets/img/brand/Microsemi.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 12,
		name: "Actel",
		classification: "0",
		brandImage: require('@/assets/img/brand/Actel.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 13,
		name: "MACCM",
		classification: "0",
		brandImage: require('@/assets/img/brand/MACCM.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 14,
		name: "TriQuint",
		classification: "0",
		brandImage: require('@/assets/img/brand/TriQuint.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 15,
		name: "avago",
		classification: "0",
		brandImage: require('@/assets/img/brand/avago.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 16,
		name: "SAMSUNG",
		classification: "0",
		brandImage: require('@/assets/img/brand/samsung.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 17,
		name: "MICRON",
		classification: "0",
		brandImage: require('@/assets/img/brand/MICRON.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 18,
		name: "RENESAS",
		classification: "0",
		brandImage: require('@/assets/img/brand/RENESAS.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 19,
		name: "Lattice",
		classification: "0",
		brandImage: require('@/assets/img/brand/Lattice.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 20,
		name: "ON",
		classification: "0",
		brandImage: require('@/assets/img/brand/ON.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 21,
		name: "PICO",
		classification: "0",
		brandImage: require('@/assets/img/brand/PICO.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 22,
		name: "TE",
		classification: "1",
		brandImage: require('@/assets/img/brand/TE.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 23,
		name: "LEMO",
		classification: "1",
		brandImage: require('@/assets/img/brand/LEMO.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 24,
		name: "DEUTSCH * TE",
		classification: "1",
		brandImage: require('@/assets/img/brand/DEUTSCH.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 25,
		name: "DMC",
		classification: "1",
		brandImage: require('@/assets/img/brand/DMC.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 26,
		name: "ERNI",
		classification: "1",
		brandImage: require('@/assets/img/brand/ERNI.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 27,
		name: "Glenair",
		classification: "1",
		brandImage: require('@/assets/img/brand/Glenair.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 28,
		name: "Esterline",
		classification: "1",
		brandImage: require('@/assets/img/brand/Esterline.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 29,
		name: "ITT",
		classification: "1",
		brandImage: require('@/assets/img/brand/ITT.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 30,
		name: "Amphenol",
		classification: "1",
		brandImage: require('@/assets/img/brand/Amphenol.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 31,
		name: "Reychem",
		classification: "1",
		brandImage: require('@/assets/img/brand/Reychem.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 32,
		name: "TROMPETER",
		classification: "1",
		brandImage: require('@/assets/img/brand/TROMPETER.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 33,
		name: "samtec",
		classification: "1",
		brandImage: require('@/assets/img/brand/samtec.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 34,
		name: "CINCH",
		classification: "1",
		brandImage: require('@/assets/img/brand/CINCH.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 35,
		name: "AirBorn",
		classification: "1",
		brandImage: require('@/assets/img/brand/AirBorn.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 36,
		name: "JUDD WIRE INC",
		classification: "1",
		brandImage: require('@/assets/img/brand/JUDD_WIRE_INC.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 37,
		name: "harbour",
		classification: "1",
		brandImage: require('@/assets/img/brand/harbour.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 38,
		name: "TRI-STAR",
		classification: "1",
		brandImage: require('@/assets/img/brand/TRI-STAR.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 39,
		name: "exans",
		classification: "1",
		brandImage: require('@/assets/img/brand/exans.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 40,
		name: "Ulti-mate",
		classification: "1",
		brandImage: require('@/assets/img/brand/Ulti-mate.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 41,
		name: "GORE",
		classification: "1",
		brandImage: require('@/assets/img/brand/GORE.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 42,
		name: "C&K",
		classification: "2",
		brandImage: require('@/assets/img/brand/C&K.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 43,
		name: "COLE",
		classification: "2",
		brandImage: require('@/assets/img/brand/COLE.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 44,
		name: "grayhill",
		classification: "2",
		brandImage: require('@/assets/img/brand/grayhill.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 45,
		name: "Honeywell",
		classification: "2",
		brandImage: require('@/assets/img/brand/Honeywell.jpg'),
		introduction: null,
		state: "0"
	}];
	return rows;
}
